const HEX_RE = /^#[0-9a-fA-F]{6}$/;

export const normalizeHexColor = (color, fallback = '#2563eb') => {
  const value = String(color || '').trim();
  if (HEX_RE.test(value)) {
    return value.toLowerCase();
  }
  return fallback;
};

const parseHex = (hex) => {
  const normalized = normalizeHexColor(hex);
  return {
    r: parseInt(normalized.slice(1, 3), 16),
    g: parseInt(normalized.slice(3, 5), 16),
    b: parseInt(normalized.slice(5, 7), 16)
  };
};

const toHex = (r, g, b) => {
  const clamp = (value) => Math.max(0, Math.min(255, Math.round(value)));
  return `#${[clamp(r), clamp(g), clamp(b)]
    .map((channel) => channel.toString(16).padStart(2, '0'))
    .join('')}`;
};

export const mixHexColors = (hex, targetHex, amount) => {
  const base = parseHex(hex);
  const target = parseHex(targetHex);
  const weight = Math.max(0, Math.min(1, amount));
  return toHex(
    base.r + (target.r - base.r) * weight,
    base.g + (target.g - base.g) * weight,
    base.b + (target.b - base.b) * weight
  );
};

export const buildCustomThemeCssVars = (primaryColor) => {
  const primary = normalizeHexColor(primaryColor);
  return {
    '--sf-50': mixHexColors(primary, '#ffffff', 0.92),
    '--sf-100': mixHexColors(primary, '#ffffff', 0.84),
    '--sf-500': mixHexColors(primary, '#ffffff', 0.35),
    '--sf-600': primary,
    '--sf-700': mixHexColors(primary, '#000000', 0.18),
    '--sf-800': mixHexColors(primary, '#000000', 0.32)
  };
};
